import { keepPreviousData, useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferStatsDto } from '../types';
import type { TransfersFilters } from './use-transfers.ts';

export const useTransferStats = (filters: TransfersFilters) => {
  const { projectId } = useParams();

  return useQuery<TransferStatsDto>({
    queryKey: ['transfer-stats', projectId, filters],
    queryFn: () =>
      apiClient.get(`/v1/projects/${projectId}/transfers/stats`, {
        params: {
          ...filters,
          dateFrom: filters.dateFrom
            ? dayjs(filters.dateFrom).startOf('day').toISOString()
            : undefined,
          dateTo: filters.dateTo ? dayjs(filters.dateTo).startOf('day').toISOString() : undefined,
        },
      }),
    placeholderData: keepPreviousData,
    enabled: !!projectId,
  });
};
